import { render, staticRenderFns } from "./SwitchLanguage.vue?vue&type=template&id=3b86c42e&scoped=true"
import script from "./SwitchLanguage.vue?vue&type=script&lang=js"
export * from "./SwitchLanguage.vue?vue&type=script&lang=js"
import style0 from "./SwitchLanguage.vue?vue&type=style&index=0&id=3b86c42e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86c42e",
  null
  
)

export default component.exports